import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  // Safely attach/detach scroll listener
  useEffect(() => {
    const handleScroll = () => {
      try {
        setIsScrolled(window.scrollY > 50);
      } catch (e) {
        console.error('Error checking scroll position:', e);
      }
    };

    window.addEventListener('scroll', handleScroll);
    // Initial check in case the page is already scrolled
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    try {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (e) {
      console.error('Failed to scroll to top:', e);
    }
  };

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/financial-success', label: 'Our Solutions' },
    { path: '/about', label: 'Our Legacy' },
    { path: '/calculator', label: 'Severity Calculator' },
    { path: '/contact', label: 'Begin Your Journey' },
  ];

  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-black shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          <Link
            to="/"
            onClick={scrollToTop}
            className="text-cream text-2xl font-bold tracking-wide whitespace-nowrap"
          >
            The Real Problem Company
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={scrollToTop}
                className={`text-base font-medium transition-colors whitespace-nowrap ${
                  location.pathname === link.path
                    ? 'text-gold'
                    : 'text-white hover:text-gold'
                }`}
              >
                {link.label}
              </Link>
            ))}

            <Link
              to="/contact"
              onClick={scrollToTop}
              className="bg-white text-black px-6 py-3 rounded-full font-semibold hover:bg-gold hover:text-black transition-all whitespace-nowrap"
            >
              Identify Your Problem
            </Link>
          </div>

          <button className="md:hidden text-white w-10 h-10 flex items-center justify-center">
            <i className="ri-menu-line text-2xl"></i>
          </button>
        </div>
      </div>
    </motion.nav>
  );
};

export default Navigation;
